export default __webpack_public_path__ + "static/media/dark-theme.9189dcaa.png";